import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import Button from "Components/Form/Button";

export const ChecklistColumn = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 15,
}));

export const TooltipStyle = styled(Tooltip)(() => ({
  cursor: "help",
  display: "flex",
}));

export const PicturesIconWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: 4,
  justifyContent: "center",

  backgroundColor: colors.gray50,
  border: `1px solid ${colors.gray200}`,
  borderRadius: 100,
  padding: "4px 8px",
}));

export const CreateInventoryButton = styled(Button)({
  width: 175,
  "& > span:first-of-type": {
    marginRight: 2.5,
  },
});

export const CreateInventoryButtonLabel = styled("span")({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0.1,
});

export const ViewInventoryButton = styled(Button)({
  width: 160,
  "& > span:first-of-type": {
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.1,
  },
});

export const PicturesCount = styled("div")(() => ({
  color: colors.gray500,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  marginLeft: 4,
}));

const styles = makeStyles(() => ({
  iconExtraAction: {
    cursor: "pointer",
  },
  changeButtonStatus: {
    whiteSpace: "nowrap",
  },
  inputFile: {
    display: "none",
  },
  descriptionTags: {
    verticalAlign: "middle",
  },
  displayFlexCenterDiv: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 4,
    marginLeft: 4,
    paddingInline: 2,
  },
  tag: {
    padding: "4px 8px",
    backgroundColor: colors.gray50,
    border: `1px solid ${colors.gray200}`,
    borderRadius: 100,
    gap: 4,
  },
}));

export default styles;
